/* ==========================================================================
   Mori Scratch Card Popup — yerel dil cevirisi
   Kaynak: kampanya panelindeki metinler (Design > Global/Scratch/Win/Contact/
   Discount + Teaser), 2026 SUMMER kampanyasi.

   Ceviriler HTML sinifina degil, INGILIZCE METNIN KENDISINE bagli.
   Tanimadigi cumleye DOKUNMAZ, Ingilizce birakir. Kampanya metni degisirse
   yanlis cumle basmaz — sadece cevrilmemis kalir.

   Sayilar # ile soyutlanir: "40% off" ve "30% off" ayni anahtara duser,
   ceviride {0} {1} orijinal sayilarla dolar. Kampanyada yuzdeyi degistirirsen
   bu dosyaya dokunman gerekmez.

   Cevrilemeyen cumleleri gormek icin konsola:  __spI18nEksik

   Dosya: assets/scratch-popup-i18n.js
   theme.liquid icinde </body> ONCESINE:
     <script src="{{ 'scratch-popup-i18n.js' | asset_url }}" defer></script>
   ========================================================================== */

(function () {
  'use strict';

  var SOZLUK = {

    /* ================= ALMANCA =================
       DTC moda dili: samimi "du". Fransizca gibi resmi degil,
       Alman e-ticaretinde genc kadin hedef kitlede standart. */
    de: {
      'Try Your Luck':                                              'Probier dein Glück',
      'Scratch below to see what you win':                          'Rubbel frei und sieh, was du gewinnst',
      'SCRATCH HERE':                                               'HIER FREIRUBBELN',
      'Drag across the panel':                                      'Mit dem Finger darüberfahren',
      "You've won":                                                 'Du hast gewonnen',
      "You've unlocked up to # off + an extra # off at checkout!":   'Du hast bis zu {0} Rabatt + {1} extra an der Kasse freigeschaltet!',
      'Stacks with sale prices - up to # off in total':             'Kombinierbar mit Sale-Preisen - insgesamt bis zu {0} Rabatt',
      'CLAIM # OFF':                                                '{0} RABATT SICHERN',
      "You've Got Up To # Off":                                     'Bis zu {0} Rabatt für dich',
      'Enter your email to reveal your code':                       'E-Mail eingeben und Code anzeigen',
      "You're In!":                                                 'Du bist dabei!',
      'Extra # off unlocked - on top of sale prices':               '{0} extra Rabatt freigeschaltet - zusätzlich zu den Sale-Preisen',
      'Copy':                                                       'Kopieren',
      'Copied':                                                     'Kopiert',
      'Apply to Checkout':                                          'Im Checkout einlösen',
      'No thanks, maybe later':                                     'Nein danke, später vielleicht',
      'Please enter a valid email address.':                        'Bitte gib eine gültige E-Mail-Adresse ein.',
      'I agree to receive marketing emails.':                       'Ich bin damit einverstanden, Marketing-E-Mails zu erhalten.',
      'I agree to receive recurring automated marketing text messages at the phone number provided.':
                                                                    'Ich bin damit einverstanden, wiederkehrende automatisierte Marketing-SMS an die angegebene Nummer zu erhalten.',
      'Scratch to win':                                             'Freirubbeln & gewinnen',
      "Don't miss your discount":                                   'Sichere dir deinen Rabatt',
      'Win':                                                        'Gewinn',
      // uygulamanin kampanya yuklenmeden once gosterdigi varsayilanlar
      'to get you started.':                                        'für deinen Start.',
      'Scratch the panel below to reveal your first-order discount.':'Rubbel das Feld frei und sieh deinen Rabatt für die erste Bestellung.',
      'Your reward':                                                'Deine Belohnung',
      '# off':                                                      '{0} Rabatt',
      'You won!':                                                   'Gewonnen!',
      'Claim it to lock in your reward.':                           'Jetzt einlösen und deine Belohnung sichern.',
      'Claim':                                                      'Einlösen',
      'Reveal my code':                                             'Code anzeigen',
      'You scratched something good.':                              'Du hast etwas Gutes freigerubbelt.',
      'Add your email to reveal the code.':                         'Gib deine E-Mail ein, um den Code zu sehen.'
    },

    /* ================= FRANSIZCA =================
       Fransiz e-ticaretinde "vous" beklenir; "tu" fazla samimi kacar. */
    fr: {
      'Try Your Luck':                                              'Tentez votre chance',
      'Scratch below to see what you win':                          'Grattez pour découvrir votre cadeau',
      'SCRATCH HERE':                                               'GRATTEZ ICI',
      'Drag across the panel':                                      'Faites glisser votre doigt',
      "You've won":                                                 'Vous avez gagné',
      "You've unlocked up to # off + an extra # off at checkout!":   "Vous avez débloqué jusqu'à {0} de réduction + {1} offerts au paiement !",
      'Stacks with sale prices - up to # off in total':             "Cumulable avec les soldes - jusqu'à {0} de réduction au total",
      'CLAIM # OFF':                                                'OBTENIR {0} DE RÉDUCTION',
      "You've Got Up To # Off":                                     "Jusqu'à {0} de réduction vous attendent",
      'Enter your email to reveal your code':                       'Saisissez votre e-mail pour révéler votre code',
      "You're In!":                                                 "C'est validé !",
      'Extra # off unlocked - on top of sale prices':               '{0} de réduction en plus - cumulable avec les soldes',
      'Copy':                                                       'Copier',
      'Copied':                                                     'Copié',
      'Apply to Checkout':                                          'Appliquer au paiement',
      'No thanks, maybe later':                                     'Non merci, une autre fois',
      'Please enter a valid email address.':                        'Veuillez saisir une adresse e-mail valide.',
      'I agree to receive marketing emails.':                       "J'accepte de recevoir des e-mails marketing.",
      'I agree to receive recurring automated marketing text messages at the phone number provided.':
                                                                    "J'accepte de recevoir des SMS marketing automatisés récurrents au numéro indiqué.",
      'Scratch to win':                                             'Grattez et gagnez',
      "Don't miss your discount":                                   'Ne manquez pas votre réduction',
      'Win':                                                        'Cadeau',
      'to get you started.':                                        'pour bien commencer.',
      'Scratch the panel below to reveal your first-order discount.':'Grattez le panneau pour découvrir votre réduction de première commande.',
      'Your reward':                                                'Votre récompense',
      '# off':                                                      '{0} de réduction',
      'You won!':                                                   'Gagné !',
      'Claim it to lock in your reward.':                           'Réclamez-la pour valider votre récompense.',
      'Claim':                                                      'Réclamer',
      'Reveal my code':                                             'Afficher mon code',
      'You scratched something good.':                              'Vous avez gratté quelque chose de bien.',
      'Add your email to reveal the code.':                         'Saisissez votre e-mail pour afficher le code.'
    },

    /* ================= ARAPCA =================
       Fusha (MSA) — Korfez pazarlarinda (SA, BH, KW, QA) standart.
       Emir kipi tekil erkek: pazarlama metinlerinde yaygin kullanim. */
    ar: {
      'Try Your Luck':                                              'جرّب حظك',
      'Scratch below to see what you win':                          'اكشط بالأسفل واكتشف ما ربحته',
      'SCRATCH HERE':                                               'اكشط هنا',
      'Drag across the panel':                                      'مرّر إصبعك على البطاقة',
      "You've won":                                                 'لقد ربحت',
      "You've unlocked up to # off + an extra # off at checkout!":   'حصلت على خصم يصل إلى {0} + خصم إضافي {1} عند الدفع!',
      'Stacks with sale prices - up to # off in total':             'يُضاف إلى أسعار التخفيضات - خصم يصل إلى {0} إجمالاً',
      'CLAIM # OFF':                                                'احصل على خصم {0}',
      "You've Got Up To # Off":                                     'لديك خصم يصل إلى {0}',
      'Enter your email to reveal your code':                       'أدخل بريدك الإلكتروني لكشف الرمز',
      "You're In!":                                                 'تم تفعيل خصمك!',
      'Extra # off unlocked - on top of sale prices':               'خصم إضافي {0} - فوق أسعار التخفيضات',
      'Copy':                                                       'نسخ',
      'Copied':                                                     'تم النسخ',
      'Apply to Checkout':                                          'تطبيق عند الدفع',
      'No thanks, maybe later':                                     'لا شكرًا، ربما لاحقًا',
      'Please enter a valid email address.':                        'يرجى إدخال بريد إلكتروني صحيح.',
      'I agree to receive marketing emails.':                       'أوافق على تلقي رسائل تسويقية عبر البريد الإلكتروني.',
      'I agree to receive recurring automated marketing text messages at the phone number provided.':
                                                                    'أوافق على تلقي رسائل نصية تسويقية آلية متكررة على الرقم المُدخل.',
      'Scratch to win':                                             'اكشط واربح',
      "Don't miss your discount":                                   'لا تفوّت خصمك',
      'Win':                                                        'اربح',
      'to get you started.':                                        'لتبدأ بها.',
      'Scratch the panel below to reveal your first-order discount.':'اكشط اللوحة بالأسفل لتكشف خصم طلبك الأول.',
      'Your reward':                                                'مكافأتك',
      '# off':                                                      'خصم {0}',
      'You won!':                                                   'لقد ربحت!',
      'Claim it to lock in your reward.':                           'احصل عليها الآن لتأمين مكافأتك.',
      'Claim':                                                      'احصل عليها',
      'Reveal my code':                                             'أظهر الرمز',
      'You scratched something good.':                              'لقد كشفت عن شيء رائع.',
      'Add your email to reveal the code.':                         'أدخل بريدك الإلكتروني لعرض الرمز.'
    }
  };

  /* Indirim kodu, e-posta ornegi gibi cevrilmemesi gerekenler */
  var DOKUNMA = /^[A-Z0-9]{4,}$|@|^\(?\d/;

  var RTL_DILLER = ['ar', 'he', 'fa', 'ur'];
  var KOKLER = ['#scratch-popup', '#sp-teaser-tab'];

  /* ------------------------------------------------------------------- */

  var dil = ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'en')
              .toLowerCase().split('-')[0];
  var sozluk = SOZLUK[dil];
  if (!sozluk) return;

  window.__spI18nEksik = [];

  function sayiRegex() {
    return /\d+(?:[.,]\d+)?\s*%|[$€£₺¥]\s?\d+(?:[.,]\d+)?|\d+(?:[.,]\d+)?\s?[$€£₺¥]/g;
  }

  /* Uygulama yer yer U+2011 kirilmayan tire, egik kesme ve kirilmayan bosluk
     kullaniyor — hepsini tekile indirger ki sozluk anahtarlari tutsun. */
  function duzle(s) {
    return s
      .replace(/[‐-―]/g, '-')
      .replace(/[‘’]/g, "'")
      .replace(/[  ]/g, ' ')
      /* Turkce klavyeden gelen harfler: uygulama ayarlarinda "Scratch to wın"
         gibi noktasiz i yazilmis. Anahtar eslesmesi bozulmasin diye tekile
         indirger — cikti metnini etkilemez, sadece sozluk aramasinda kullanilir. */
      .replace(/ı/g, 'i').replace(/İ/g, 'I')
      .replace(/ş/g, 's').replace(/Ş/g, 'S')
      .replace(/ğ/g, 'g').replace(/Ğ/g, 'G')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cevirDugum(d) {
    var ham = d.textContent;
    var duz = duzle(ham);
    if (!duz || duz.length < 2 || DOKUNMA.test(duz)) return;

    var anahtar = duz.replace(sayiRegex(), '#');
    var sablon = sozluk[anahtar];

    if (!sablon) {
      if (/[A-Za-z]{3}/.test(duz) && window.__spI18nEksik.indexOf(anahtar) === -1) {
        window.__spI18nEksik.push(anahtar);
      }
      return;
    }

    var sayilar = duz.match(sayiRegex()) || [];
    var yeni = sablon
      .replace(/\{(\d+)\}/g, function (_, i) { return sayilar[+i] !== undefined ? sayilar[+i].trim() : ''; })
      .replace(/\s{2,}/g, ' ')
      .trim();

    if (!yeni || yeni === duz) return;

    var bas = ham.match(/^\s*/)[0];
    var son = ham.match(/\s*$/)[0];
    d.textContent = bas + yeni + son;
  }

  function cevir() {
    for (var i = 0; i < KOKLER.length; i++) {
      var kok = document.querySelector(KOKLER[i]);
      if (!kok) continue;

      var y = document.createTreeWalker(kok, NodeFilter.SHOW_TEXT, null, false);
      var liste = [], n;
      while ((n = y.nextNode())) liste.push(n);
      for (var j = 0; j < liste.length; j++) cevirDugum(liste[j]);

      if (RTL_DILLER.indexOf(dil) > -1 && kok.getAttribute('dir') !== 'rtl') {
        kok.setAttribute('dir', 'rtl');
      }
    }
  }

  cevir();

  /* Popup asama degistirdikce icerik yeniden ciziliyor. Ceviri sonrasi metin
     artik sozlukte olmadigi icin dongu olusmaz. */
  if (window.MutationObserver) {
    var bekle = null;
    new MutationObserver(function () {
      clearTimeout(bekle);
      bekle = setTimeout(cevir, 40);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  [200, 600, 1500, 3000, 5000].forEach(function (ms) { setTimeout(cevir, ms); });
})();